import { Img } from 'remotion'
import { Poem } from './Poem'
import { CompositionConfig, PureProps, sansSerif } from '../config'
import { compositions } from '../config'
import NFTVerified from '../assets/NFTVerified.svg'
// Import weappCode from '../assets/PoemWikiWeappCode.jpg'

export const PureCard = (cardProps: PureProps) => {
  const { title, poem, subtitle: rawSubtitle = '', preface: rawPreface = '', poetHead = '', poet, poetVerified, location = '', date = '', translators = null }: PureProps = cardProps
  // Normalize null -> '' so downstream components can safely call string ops
  const subtitle = rawSubtitle || ''
  const preface = rawPreface || ''
  const defaults = compositions.pure({ wrap: cardProps.config.wrap, noAuthorLabel: cardProps.config.noAuthorLabel })
  const config: CompositionConfig = { ...defaults, ...cardProps.config }

  console.log('pure card props', config, poetHead.length)

  return (
    <div id="pure-card" style={{
      // display: 'flex',
      // flexDirection: 'column',
      // justifyContent: 'flex-start',
      // alignItems: 'flex-start',
      background: 'white',
      ...config.cardStyle,
      // Ensure the bottom edge doesn’t create a dark hairline - add breathing room
      paddingBottom: (config.cardStyle.paddingBottom || 0) + 1,
    }}>
      <Poem title={title} poem={poem} subtitle={subtitle}
        preface={preface} config={config} />

      <div style={{
        marginTop: 66 + 'px',
      }}>

        {location || date
          ? <div id="location-date" style={config.dateLocationStyle}>
            {date && <span>{date}</span>}
            {location && <span style={{
              marginLeft: location ? 16 + 'px' : 0,
            }}>
              {location}
            </span>}
          </div>
          : <></>
        }

        {(poet || poetHead) ? (
          <div id="authors" style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            width: `${config.maxWidth - config.cardStyle.paddingLeft}px`,
            color: '#373737',
          }}>
            {poetHead && <div style={{
              display: 'flex',
              marginTop: 4 + 'px',
              marginBottom: 4 + 'px',
              marginRight: 16 + 'px',
              overflow: 'hidden',
            }}>
              <Img src={poetHead} style={{
                borderRadius: '50%',
                width: 48 + 'px',
                height: 48 + 'px',
              }} />
            </div>}
            <span style={{
              padding: 0,
              fontFamily: config.authorStyle.fontFamily,
              fontWeight: config.authorStyle.fontWeight,
              // fontSize: config.innerLineStyle.fontSize,
              fontSize: config.authorStyle.fontSize,
              letterSpacing: '0.00625em',
              lineHeight: '1em',
            }}>
              {!config.noAuthorLabel && !poetHead ? '作者 / ' : ''}
              {config.noAuthorLabel ? <em>{poet}</em> : poet}
              {poetVerified && <Img style={{
                width: 24 + 'px',
                height: 24 + 'px',
                marginLeft: 16 + 'px',
                verticalAlign: 'bottom',
              }}
                src={NFTVerified} />}
            </span>
          </div>
        ) : null}

        {translators ? (
          <div id="translators" style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            width: `${config.maxWidth - config.cardStyle.paddingLeft}px`,
            color: '#373737',
            marginTop: 16 + 'px',
          }}>
            <span style={{
              padding: 0,
              fontFamily: config.authorStyle.fontFamily,
              fontWeight: config.authorStyle.fontWeight,
              fontSize: config.authorStyle.fontSize,
              letterSpacing: '0.00625em',
              lineHeight: '1em',
            }}>
              译者 / {translators}
            </span>
          </div>
        ) : null}
      </div>


      <div id="extra" style={{
        width: '100%',
        marginTop: 130 + 'px',
      }}
      >
        <div style={{
          height: '160px',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
        >
          <p style={{
            fontSize: '24px',
            fontWeight: 300,
            color: '#909090',
            width: '7em',
            fontFamily: sansSerif,
            borderTop: '1px solid black',
            paddingTop: '.8em',
            marginTop: '0'
          }}
          >诗歌维基<br />poemwiki
          </p>

          {/* <Img
              src={weappCode} style={{
                width: '120px'
              }}
            /> */}
        </div>
      </div>
    </div>
  )
}
